import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { OfferBox } from 'components/OfferBox/OfferBox';
import { UnavailabilityMobile } from 'components/Unavailability/Mobile';
import { OfferTrackingContextProvider } from 'context/offerTracking';
import { OfferViewContext, OfferViewType } from 'context/offerViewContext';
import { useHotelOverlayOffersFilters } from 'hooks/useHotelOverlayOffersFilters';
import { showOverlay } from 'modules/overlay/slice';
import { OverlayType } from 'modules/overlay/types';
import { getIsAnchorHotel } from 'modules/sapiSearch/selectors';
import { getIsOTAMode } from 'modules/search/selectors';
import { Stack } from '@daedalus/atlas/helpers/Stack';
import { useTrackingTeam } from '@daedalus/core/src/analytics/components/TeamContext';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Page } from '@daedalus/core/src/analytics/types/Events';
import { FilterSource } from '../OffersFilters/constants';
import { AllOffersOverlay } from './AllOffersOverlay';
import { UnavailabilityWithFilters } from './Unavailability';
import { useCachedSearchTopOffers } from './useCachedSearchTopOffers';
interface Props {
  hotelId: string;
}
const SOURCE_COMPONENT = 'MobileHotelViewTopOffers';
const AvailabilityPaneWrapper = /*#__PURE__*/styled('div')({
  name: "AvailabilityPaneWrapper",
  class: "a11mghdp",
  propsAsIs: false
});
const OffersOrUnavailability: React.FC<Props> = ({
  hotelId
}) => {
  const dispatch = useDispatch();
  const team = useTrackingTeam();
  const {
    offerEntity,
    isComplete,
    searchedParameters
  } = useCachedSearchTopOffers({
    hotelId
  });
  const {
    activeOffersFilters
  } = useHotelOverlayOffersFilters();
  const hasActiveFilters = !!activeOffersFilters.length;
  const isOTAMode = useSelector(getIsOTAMode);
  const isAnchor = useSelector(state => getIsAnchorHotel(state, hotelId));
  const onShowAllOffersClick = () => {
    dispatch(showOverlay({
      type: OverlayType.HotelAllOffers,
      params: {
        hotelId
      },
      team
    }));
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.HotelMoreDealsOption,
      action: Action.Clicked,
      team
    }));
  };
  return <OfferTrackingContextProvider offerEntity={offerEntity} parameters={searchedParameters}>
      <OfferBox isOTAMode={isOTAMode} offerEntity={offerEntity} isLoading={!isComplete} primaryOfferVariant="PrimaryMultiColumn" component={SOURCE_COMPONENT} onSeeMoreClick={onShowAllOffersClick} unavailabilitySlot={hasActiveFilters ? <UnavailabilityWithFilters source={FilterSource.RemoveQuickFilters} /> : <AvailabilityPaneWrapper>
              <UnavailabilityMobile hotelId={hotelId} sourceComponentPrefix="MobileHotelView" />
            </AvailabilityPaneWrapper>} shouldRenderUnavailabilitySlot={isAnchor} page={Page.Accommodation} />
    </OfferTrackingContextProvider>;
};
export const Offers: React.FC<Props> = ({
  hotelId
}) => {
  return <>
      <Stack space="s300">
        <OffersOrUnavailability hotelId={hotelId} />
      </Stack>
      <OfferViewContext.Provider value={OfferViewType.AP_DETAILS_OVERLAY}>
        <AllOffersOverlay sourceComponent="MobileAllOffersOverlay" />
      </OfferViewContext.Provider>
    </>;
};

require("./Offers.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Offers.tsx");